import React, { useState } from "react";
import { Play } from "lucide-react";
import { useSettings } from "@/context/SettingsContext";

export default function VideoSection() {
  const { settings } = useSettings();
  const video = settings?.video;
  const [playing, setPlaying] = useState(false);
  if (!video || !video.active) return null;

  const steps = video.steps || [];

  return (
    <section id="process" className="py-16 sm:py-24 bg-forest-950 text-cream">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-2xl">
          <p className="text-wheat text-xs font-semibold uppercase tracking-widest mb-3">Behind the Aata</p>
          <h2 className="font-serif text-3xl sm:text-4xl font-bold text-cream">{video.title || "How Areeba Is Made"}</h2>
          <p className="text-cream/70 mt-3 text-base">{video.description}</p>
        </div>

        <div className="mt-10 grid lg:grid-cols-3 gap-8 items-start">
          <div className="lg:col-span-2">
            <div className="relative rounded-2xl overflow-hidden aspect-video bg-black/40 border border-white/10" data-testid="process-video">
              {playing && video.video_url ? (
                <video
                  src={video.video_url}
                  poster={video.poster}
                  controls
                  autoPlay
                  playsInline
                  className="h-full w-full object-cover"
                  data-testid="process-video-player"
                >
                  {video.captions_url && <track kind="captions" src={video.captions_url} default />}
                </video>
              ) : (
                <button
                  onClick={() => video.video_url && setPlaying(true)}
                  className="group relative h-full w-full"
                  data-testid="process-video-play"
                >
                  <img src={video.poster} alt={video.title} className="h-full w-full object-cover" loading="lazy" />
                  <div className="absolute inset-0 bg-forest-dark/40 flex items-center justify-center">
                    <span className="h-20 w-20 rounded-full bg-wheat text-forest-dark flex items-center justify-center shadow-xl group-hover:scale-110 transition-transform">
                      <Play size={32} className="ml-1" fill="currentColor" />
                    </span>
                  </div>
                  {!video.video_url && (
                    <span className="absolute bottom-4 left-4 right-4 text-center text-sm bg-black/50 rounded-lg py-2 text-cream/90">
                      Making-process video coming soon.
                    </span>
                  )}
                </button>
              )}
            </div>
          </div>

          <ol className="space-y-3">
            {steps.map((s, i) => (
              <li key={s} className="flex items-center gap-3" data-testid={`process-step-${i}`}>
                <span className="h-8 w-8 shrink-0 rounded-full bg-wheat/15 text-wheat font-mono text-sm flex items-center justify-center">{i + 1}</span>
                <span className="text-cream/85 text-sm">{s}</span>
              </li>
            ))}
          </ol>
        </div>
      </div>
    </section>
  );
}
